<template>
  <div>
    <hero-bar :has-right-visible="true">
      <div slot="title">{{binominalName}}</div>
      <div slot="sub-title">{{ eventName }} </div>
      <div slot="right">
        <div class="level level-bordered">
          <div class="level-item has-text-centered border-right">
            <div>
              <p class="title is-5" :style="{color:colorScore}">{{score}}</p>
              <p class="heading">Nota Final</p>
            </div>
          </div>
          <div class="level-item has-text-centered border-right">
            <div>
              <p class="title is-5" :style="getStyleScore(maxScore)">{{maxScore.toFixed(1)}}</p>
              <p class="heading">Puntaje Máximo</p>
            </div>
          </div>
          <div class="level-item has-text-centered">
            <div>
              <p class="title is-5" :style="getStyleScore(minScore)">{{minScore.toFixed(1)}}</p>
              <p class="heading">Puntaje Mínimo</p>
            </div>
          </div>
        </div>
      </div>
    </hero-bar>
    <section class="section is-main-section">
      <b-notification aria-close-label="Close notification" type="is-primary">
        <p style="color: #424242">Las notas ingresadas por jueces <b>no oficiales</b> no son consideradas dentro de la calificación final del jinete.</p>
      </b-notification>
      <div class="columns">
        <div class="column">
          <judges-detail :execution-id="executionId" :execution="execution" :evaluation="evaluation" :selected-judge.sync="selectedJudge" :key="`judges-table-${componentKey}`"/>
        </div>
      </div>
      <div class="columns" v-if="selectedJudge">
        <div class="column">
          <binomial-edit-results :lesson-id="lessonId" :execution-id="executionId" :judge.sync="selectedJudge" :result-execution="result_execution" :lesson="lesson" @saved="updateView"/>
        </div>
      </div>
      <div class="columns" v-else>
        <div class="column">
          <binomial-results :lesson-id="lessonId" :execution-id="executionId" :judges="judges" :result-execution="result_execution" :lesson="lesson" @min-score="minScore = $event" @max-score="maxScore = $event"/>
        </div>
      </div>
    </section>
  </div>
</template>

<script>

import HeroBar from '@/components/HeroBar'
import BinomialResults from './components/BinomialResults'
import BinomialEditResults from './components/BinomialEditResults'
import JudgesDetail from './components/JudgesDetail'
// import EventService from '@/services/ExerciseService'

import ExecutionService from '@/services/ExecutionService'
import EventService from '@/services/EventService'

export default {
  components: {
    HeroBar,
    BinomialResults,
    JudgesDetail,
    BinomialEditResults
  },
  created () {
    this.initView()
  },
  data () {
    return {
      eventId: null,
      executionId: null,
      execution: null,
      lessonId: null,
      result_execution: null,
      judges: [],
      lesson: null,
      evaluation: null,
      minScore: 0,
      maxScore: 0,
      selectedJudge: null,
      componentKey: 1
    }
  },
  computed: {
    score () {
      return this.result_execution != null ? this.result_execution.final_score.toFixed(2) + '%' : 'S/I'
    },
    colorScore () {
      return this.result_execution != null && this.result_execution.final_score > 60 ? '#23d160' : '#ff3860'
    },
    binominalName () {
      let name = ''
      if (this.execution != null) {
        let horse = this.execution.horse
        let rider = this.execution.rider
        name = `${rider.lastname} ${rider.name} - ${horse.name}`
      }
      return name
    },
    eventName () {
      let event = this.evaluation ? this.evaluation.name : ''
      let lesson = this.lesson ? this.lesson.name : ''
      return `${event} - ${lesson}`
    }
  },
  methods: {
    initView () {
      this.eventId = this.$route.params.eventId
      this.executionId = this.$route.params.executionId
      this.getEvent()
      this.getExecution()
    },
    updateView () {
      this.initView()
      this.forceRendering()
    },
    forceRendering () {
      this.componentKey++
    },
    getStyleScore (score) {
      let style
      if (this.maxScore === score) {
        style = 'color: #23d160'
      } else if (this.minScore === score) {
        style = 'color: #ff3860 '
      }
      return style
    },
    async getExecution () {
      let response = await ExecutionService.getExecution(this.eventId, this.executionId)
      this.execution = response.data.data
      this.lessonId = this.execution.lesson.id
      this.lesson = this.execution.lesson
      this.result_execution = this.execution.result_execution
      this.judges = this.execution.judges_executions.map((x) => x.judge)
    },
    async getEvent () {
      let response = await EventService.getEvent(this.eventId)
      this.evaluation = response.data.data
    }
  }
}
</script>
